
import React from 'react';
import { Users, UserCheck, Award, Heart } from 'lucide-react';
import ComingSoonLayout from '../components/layout/ComingSoonLayout';

const TimKKN: React.FC = () => {
  return (
    <ComingSoonLayout
      title="Tim KKN"
      subtitle="Meet Our Amazing Team"
      description="Halaman ini akan memperkenalkan tim KKN UNSOED 2025 yang luar biasa, termasuk profil anggota, latar belakang pendidikan, peran dalam tim, dan kontribusi masing-masing dalam program."
      icon={<Users className="h-12 w-12 sm:h-16 sm:w-16 text-white" />}
     
      estimatedDate="Team Reveal Soon"
    />
  );
};

export default TimKKN;